module.exports = "/assets/dist/images/bodystyles_wagons.png?e57bf27cf74babed8c1ea37d37ce905e";